import { Dropdown } from "primereact/dropdown";
import React, { useState } from "react";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import storage from "../../Services/Storage";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import Axios from "../../api/Axios";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";

const WorkshopDiscountDefinition = () => {
    const auth = storage.getLocal("user");
    const files = [
        { name: "CSV", code: "CSV" },
        { name: "XLSX", code: "XLSX" },
    ];
    const [selectedFile, setSelectedFile] = useState(files[1]);
    const [loadingExcel, setLoadingExcel] = useState(false);

    console.log(auth);

    const downloadFileData = async () => {
        const GetCompState_URL =
      "WorkshopDiscountDefinition/GetWorkshopExportData?";
        const GetCompState_api = `${GetCompState_URL}CompId=${auth.CompId}`;
        try {
            setLoadingExcel(true);
            const res = await Axios.get(GetCompState_api);
            if (res.data.Data) {
                let filename =
          selectedFile.name == "XLSX"
              ? `WorkShopDisct${GetDateFormat()}.xlsx`
              : `WorkShopDisct${GetDateFormat()}.csv`;
                downloadExcel(res.data.Data, filename);
                setLoadingExcel(false);
            } else {
                toast.warn("No data is available.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            }
        } catch (error) {
            toast.warn(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            setLoadingExcel(false);
        }
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Workshop Discount Definition</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block">
                                <label className="form-label">File Type</label>
                                <Dropdown
                                    value={selectedFile}
                                    onChange={(e) => setSelectedFile(e.value)}
                                    options={files}
                                    optionLabel="name"
                                    placeholder="Select a File Type"
                                    checkmark={true}
                                    highlightOnSelect={false}
                                />
                            </div>
                            <div className="text-end mt-3">
                                {/* <button
                  type="button"
                  className="btn btn-primary"
                  onClick={downloadFileData}
                >
                  Export
                </button> */}
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={downloadFileData}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Save As Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end">
                                <img
                                    src={require("../../Assets/Images/discount.png")} className="Side_Img"/>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default WorkshopDiscountDefinition;
